/**
 * Person Image Sizes:
 * mobile1X: for mobile/small sizes
 * desktop1X: for desktop/table/large sizes
 * mobile2X: double mobile1X
 * desktop2X: double desktop1X
 */

export const dataModel = {
  storybook: true,
  url: "/api/peoplelisting",
  perPage: 19,
  cta: {
    href: "/",
    text: "Faculty & Staff",
    target: "",
  },
  ad1: {
    href: "/",
    text: "Ad 1",
    target: "",
  },
  ad2: {
    href: "/",
    text: "Ad 2",
    target: "",
  },
  boards: [
    {
      type: "person",
      key: "dsdsfkj",
      title: "Devin Thomas Quirk",
      body: ["test", "test 2"],
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
      quoteText: "some text to appear on hover",
    },
  ],
  loadMoreText: "Meet More People",
  filters: [
    {
      label: "All People",
      value: "",
    },
    {
      label: "Alumni",
      value: "{8A59504F-4A1E-415C-BC90-4791A7943296}",
    },
    {
      label: "Students",
      value: "{39ED9C06-C627-40A5-8DE3-BB5782E9E056}",
    },
    {
      label: "Kellogg Leadership",
      value: "{C96E7A37-F04C-444A-B104-A120F5DD3F38}",
    },
  ],
  filterQuerystringKey: "personType",
};

export const dataQuery = {
  pageId: "d669a326-86bd-4394-872e-ce79a537dbbe",
  listingId: "430be22d-6e5f-46ef-afac-0ddb8dac19c2",
};

export const mockApiResponse = {
  request: {
    pageId: "110d559f-dea5-42ea-9c1c-8a5df7e70ef9",
    page: 1,
    perPage: 19,
    sortBy: "null",
    sortOrder: "null",
    queryParameters: {
      listingId: "880c21a7-09f4-4c6a-9b19-2081002d11d0",
    },
  },
  totalResults: 14,
  results: [
    {
      type: "person",
      key: "qweddoiufjk",
      title: "Devin Thomas Quirk",
      body: ["test", "test 2"],
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
      imageIcon: false,
    },
    {
      type: "person",
      key: "dsdsfkj",
      title: "Devin Thomas Quirk",
      body: ["test", "test 2"],
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
      quoteText: "some text to appear on hover",
      imageIcon: true,
    },
    {
      type: "person",
      key: "jfjdksfue",
      title: "Devin Thomas Quirk",
      body: ["test", "test 2"],
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
      imageIcon: true,
    },
    {
      type: "person",
      key: "jfjdkesfue",
      title: "Devin Thomas Quirk",
      body: ["test", "test 2"],
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
      quoteText: "some text to appear on hover",
      imageIcon: false,
    },
    {
      type: "person",
      key: "yeksdffhhf",
      title: "Devin Thomas Quirk",
      body: ["test", "test 2"],
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
      imageIcon: true,
    },
    {
      type: "person",
      key: "sdajkhfbvbbvhdf",
      title: "Devin Thomas Quirk",
      body: ["test", "test 2"],
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
      imageIcon: true,
    },
    {
      type: "person",
      key: "sfnbvyqrwyehsg",
      title: "Devin Thomas Quirk",
      body: ["test", "test 2"],
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
      quoteText: "some text to appear on hover",
      imageIcon: true,
    },
    {
      type: "person",
      key: "ppsssoosdfsdf",
      title: "Devin Thomas Quirk",
      body: ["test", "test 2"],
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
      quoteText: "some text to appear on hover",
      imageIcon: true,
    },
    {
      type: "person",
      key: "sdfjksdlkfaababab",
      title: "Devin Thomas Quirk",
      body: ["test", "test 2"],
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
      quoteText: "some text to appear on hover",
      imageIcon: true,
    },
    {
      type: "person",
      key: "qweoiufjk",
      title: "Devin Thomas Quirk",
      body: ["test", "test 2"],
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
      quoteText: "some text to appear on hover",
      imageIcon: true,
    },
    {
      type: "person",
      key: "dsdssssfkj",
      title: "Devin Thomas Quirk",
      body: ["test", "test 2"],
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
      quoteText: "some text to appear on hover",
      imageIcon: true,
    },
    {
      type: "person",
      key: "jfjdksdfsdsfue",
      title: "Devin Thomas Quirk",
      body: ["test", "test 2"],
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
      quoteText: "some text to appear on hover",
      imageIcon: false,
    },
    {
      type: "person",
      key: "jfjdkesdddfue",
      title: "Devin Thomas Quirk",
      body: ["test", "test 2"],
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
      quoteText: "some text to appear on hover",
      imageIcon: false,
    },
    {
      type: "person",
      key: "jfjdkeeeesdddfue",
      title: "Devin Thomas Quirk",
      body: ["test", "test 2"],
      displayUrl: "null",
      contentUrl: "",
      images: {
        mobile1X: "https://via.placeholder.com/250x214",
        desktop1X: "https://via.placeholder.com/350x300",
        mobile2X: "https://via.placeholder.com/500x428",
        desktop2X: "https://via.placeholder.com/700x600",
      },
      imageAlt: "alt",
      quoteText: "some text to appear on hover",
      imageIcon: true,
    },
  ],
  facets: [],
};
